import {decodeEntities} from "@wordpress/html-entities";
export const CONFIG = {
    API: {
        URL: process.env.API_URL ? process.env.API_URL : window.location.protocol + '//' + window.location.hostname,
        REQUIRE_AUTH: process.env.API_REQUIRE_AUTH ? process.env.API_REQUIRE_AUTH : false ,
        USERNAME: process.env.API_USERNAME ? process.env.API_USERNAME : '',
        PASSWORD: process.env.API_PASSWORD ? process.env.API_PASSWORD : ''
    }, // Fetched from .env
    defaultPageSlug: null, //Will be populated by wordpress
	customPostTypes: null, //Will be populated by wordpress
    components: {}, //Will be populated by wordpress
    page_404: {
        title: '',
        description: '',
        content: '',
        template: '404',
        slug: '404'
    }, //Will be populated by wordpress
    polyfill: {
        fills: ['Promise', 'fetch', 'Map', 'Object.assign'],
        options: [],
        minify: true,
        rum: false
    },
    scrollToTopOnRouteChange: true,
    wpJSOptions: {
        onSuccess: (rsp) => {
            return decodeEntities(rsp);
        }
    },
    routing: [
        // { domain: '', lang: '', path: '' } // domain/path and language code
    ],
    multiLangMode: 'domain', // domain or path
    multiLangSupport: false
};